/**
 * Default LibModule
 */
window.LibModule = class LibModule {
    constructor() {

        // Lib event before.document.ready
        if (typeof this.beforeDOMReady === 'function') {
            $(Lib).on('before.document.ready', () => {
                this.beforeDOMReady.apply(this);
            });
        }

        // Lib event document.ready
        if (typeof this.DOMReady === 'function') {
            $(Lib).on('document.ready', () => {
                this.DOMReady.apply(this);
            });
        }

        // Lib event after.document.ready
        if (typeof this.afterDOMReady === 'function') {
            $(Lib).on('after.document.ready', () => {
                this.afterDOMReady.apply(this);
            });
        }
    }
};
